import React, { useState } from 'react';

function ExperienceItem({ experience, onEdit, onDelete }) {
  const startDate = new Date(experience.startDate);
  const monthStartYear = startDate.toLocaleString('default', { month: 'long', year: 'numeric' });
  const endMonthYear = experience.currentJob ? 'Present' : new Date(experience.endDate).toLocaleString('default', { month: 'long', year: 'numeric' });

  return (
    <div key={experience.id} className="experience-item">
      <div className="experience-content">
        <div>
          {experience.isConsultancy && (
            <div className="text-muted font-italic small mb-1">
              <span>Consultancy firm: {experience.consultancyCompany}</span>
            </div>
          )}
          <strong>{experience.jobTitle}</strong> at {experience.employer}, {experience.town}
          <br />
          <span className="experience-dates">
            {monthStartYear} - {endMonthYear}
          </span>
          <br />
          <p style={{marginTop: '1em'}}>{experience.description}</p>
        </div>

        <div className="experience-actions" style={{ marginTop: '10px' }}>
          <i className="fa fa-pencil edit-icon" title="Edit" onClick={() => onEdit(experience)} style={{ cursor: 'pointer', marginRight: '10px' }}></i>
          <i className="fa fa-trash delete-icon" title="Delete" onClick={() => onDelete(experience)} style={{ cursor: 'pointer' }}></i>
        </div>
      </div>
    </div>
  );
}

export default ExperienceItem;
